import React from "react";
import { string } from "prop-types";
import * as style from "./styles.module.scss";

const LabeledValue = ({ header, children, className = "" }) => {
  return (
    <span className={`${style.subsection__wrapper} ${className}`}>
      <p className={`${style.subsection__title}`}>{header.toUpperCase()}</p>
      <b>{children}</b>
    </span>
  );
};

LabeledValue.propTypes = {
  children: string,
  header: string.isRequired,
  className: string,
};

export default LabeledValue;
